import interactions from './interactions';
import pageview from './pageview';
import { trackScrolling } from './scrollTracking';

export default { ...pageview, ...interactions, trackScrolling };
